import {forwardRef, useEffect, useState} from "react";
import {getImagePath, imgPathPerfix} from "@/utils";
import {t} from "i18next";
import {getLeftPartSvg} from "@/views/Home/FirstInitIcon";

const FirstInitGuiderPage = forwardRef((props:{onStartClick:any},ref)=> {
    const ARRAY_GUIDER = [
        {
            image: 'guider_0',
            title: 'GuiderTitle1',
            subTitle: 'GuiderSubTitle1'
        },
        {
            image: 'guider_1.png',
            title: 'GuiderTitle1_1',
            subTitle: 'GuiderSubTitle1_1'
        },
        {
            image: 'guider_2.png',
            title: 'GuiderTitle2_1',
            subTitle: 'GuiderSubTitle2_1'
        },
        {
            image: 'guider_3.png',
            title: 'GuiderTitle3_1',
            subTitle: 'GuiderSubTitle3_1'
        }
    ]

    const arrayItems = [
        {
            id: "localStorage",
            image: 'init_guider_1',
            title: t('Local file storage'),
            subTitle: t("LocalfileStorageSmall"),
            width: '36px',
            height: '26px'
        },
        {
            id: "fullFeatured",
            image: 'init_guider_2',
            title: t('Infinite canvas'),
            subTitle: t("InfiniteCanvasSmall"),
            width: '33px',
            height: '27px'
        },
        {
            id: "powerfullPdf",
            image: 'init_guider_3',
            title: t('Powerful highlighting'),
            subTitle: t("PowerfulHighlightSmall"),
            width: '31px',
            height: '29px'
        },
        // {
        //     id:"nestedBoards",
        //     image:'wel_nested_boards',
        //     title:t('Nested boards'),
        //     subTitle:t("UseBoardsAndCards"),
        //     width:'32px',
        //     height:'26px'
        // },
        {
            id: "organizeLocal",
            image: 'init_guider_4',
            title: t('OrganizeLocalFiles'),
            subTitle: t("OrganizeLocalFilesSmall"),
            width: '30px',
            height: '26px'
        }
    ]

    const getImageRateWidth = ()=>{
        // 1920/1080   451
        const nW = document.body.clientWidth;
        const nH = document.body.clientHeight;
        //计算宽度.
        const nRateW = nW*451 / 1920;
        return nRateW;
    }

    const [imageWidth,setImageWidth] = useState(getImageRateWidth());
    const [selectIndex, setSelectIndex] = useState(0);

    function onResize(event){
        setImageWidth(getImageRateWidth());
    }

    useEffect(() => {
        document.body.addEventListener('resize',onResize);

        return ()=>{
            document.body.removeEventListener('resize',onResize);
        }
    }, []);


    const renderBase = () => {
        return <div className={'main-first- flex-row'} style={{
            background: 'white',
            borderRadius: '20px',
            boxShadow: '0px 4px 24px 0px rgba(0,0,0,0.2);'
        }}>
            <div className={'flex-center'} style={{width: '50%'}}>
                <div>
                    {getLeftPartSvg()}
                </div>
            </div>

            <div className={'flex-col'} style={{width: '50%', justifyContent: 'center'}}>
                <div className={'flex-col'} style={{width: '100%', marginLeft: '66px'}}>
                    <span className={'font-family-semi-bold'}
                          style={{fontSize: '32px'}}>{t("Welcome to") + t("AppName")}</span>
                    <span style={{fontSize: '16px', marginTop: '20px'}}>{t("UnlockDeeperInsights")}</span>
                    <div style={{marginTop: '0px'}}>
                        {
                            arrayItems.map(item => <div className={'flex-row-vertical-center'}
                                                        style={{marginTop: '40px'}}>
                                <img style={{width: '24px', height: '24px'}}
                                     src={imgPathPerfix() + item.image + '.svg'}/>
                                <div className={'flex-col ml-16'}>
                                    <span className={'font-family-medium'}
                                          style={{fontSize: '17px'}}>{item.title}</span>
                                    <span style={{
                                        fontSize: '15px',
                                        color: '#666666',
                                        marginTop: '6px'
                                    }}>{item.subTitle}</span>
                                </div>
                            </div>)
                        }
                    </div>
                </div>
            </div>
        </div>
    }

    return <div className={'flex-center'} style={{width: '100%', height: '100%'}}>
        <div style={{
            background: 'white',
            boxShadow: '0px 0px 8px 0px rgba(102,102,102,0.37',
            borderRadius: '20px',
            width: `85%`,
            height:`85%`
        }}>
            <div className={'flex-col'} style={{width: '100%',position:'relative',height:'100%',justifyContent:'center'}}>
                {
                    ARRAY_GUIDER.map((p, index) => {
                        return selectIndex == index ? (index == 0?renderBase():<div className={'flex-column-center'}>
                            <img style={{width: 'auto', height: `${imageWidth}px`, borderRadius: '8px'}}
                                 src={getImagePath(p.image)}/>
                            <span className={'font-family-semi-bold'} style={{
                                fontSize: '28px',
                                fontWeight: '800',
                                marginTop: '16px',
                                textAlign: 'center'
                            }}>{t(p.title)}</span>
                            <span style={{
                                fontSize: '18px',
                                marginTop: '10px',
                                textAlign: 'center',
                                height: '88px',
                                textWrap: 'wrap'
                            }}>{t(p.subTitle)}</span>
                        </div>) : <></>
                    })
                }

                <div className={'flex-row-vertical-center'} style={{marginTop: 'auto',position:'absolute',bottom:'0px',width:'100%',borderTop:'1px solid var(--line-color)',padding:'16px 22px'}}>
                    <div className={'flex-row-vertical-center'} style={{gap: '0 12px'}}>
                        {
                            ARRAY_GUIDER.map((p, index) => {
                                return <div className={'cursor-pointer'} style={{
                                    background: selectIndex == index ? 'var(--primary-color)' : '#D9D9D9',
                                    width: selectIndex == index ? '28px' : '10px',
                                    height: '10px',
                                    borderRadius: '5px'
                                }} onClick={() => {
                                    setSelectIndex(index)
                                }}></div>
                            })
                        }
                    </div>
                    <div className={'flex-row-vertical-center'} style={{marginLeft: 'auto', fontSize: '18px'}}>
                        {
                            selectIndex > 0 &&
                            <span className={'cursor-pointer'} onClick={() => {
                                let nNewIndex = selectIndex;
                                if (nNewIndex == 0) {

                                } else {
                                    setSelectIndex(nNewIndex - 1)
                                }
                            }}>{`< ${t('Back')}`}</span>
                        }

                        <div className={'button-solid-style flex-center ml-20'}
                             style={{minWidth: '102px', padding: '0 16px', fontSize: '18px', height: '46px'}}
                             onClick={() => {
                                 let nNewIndex = selectIndex;
                                 if (nNewIndex >= 3) {
                                     //结束
                                     if (props.onStartClick) {
                                         props.onStartClick();
                                     }
                                 } else {
                                     setSelectIndex(nNewIndex + 1)
                                 }
                             }}>{`${selectIndex == 3 ? t('Get started') : t('Next')} >`}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
})

export default FirstInitGuiderPage;